import React, { PureComponent, PropTypes } from 'react';
import moment from 'moment/min/moment.min';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Logo } from '../';
import messages from '../i18n';
import styles from './styles.scss';

const SECOND = 1000; // milliseconds

function calculateDelay() {
  // get the time to the closest minute
  return 60 * SECOND - (Date.now() % (60 * SECOND)); // eslint-disable-line
}

export class Header extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const delay = calculateDelay();
    this.setState({
      clock: setTimeout(() => this.startCounter(), delay),
    });
    this.getTime();
  }

  componentWillUnmount() {
    clearInterval(this.state.clock);
  }

  /**
   * a recurring method updating the clock every second.
   */
  getTime() {
    const m = moment();
    this.setState({
      time: m.format('h:mmA'),
      day: m.format('dddd'),
      date: m.format('Do MMM'),
    });
  }

  startCounter() {
    this.setState({
      clock: setInterval(() => this.getTime(), 60 * SECOND),
    });
    this.getTime();
  }

  renderLocation() {
    return this.props.location ? (
      <span>{this.props.location}</span>
    ) : (
      <span className={styles.noLocation}>
        <FormattedMessage {...messages.noLocationSet} />
      </span>
    );
  }

  /**
   * Renders the component to DOM.
   * COMPONENT LIFECYCLE HOOK (See React.js docs)
   * @return {Element} returns the element composition of the component.
   */
  render() {
    return (
      <div className={styles.header}>

        {/* Includes the tanda logo and time */}
        <div className={styles.row}>
          <Logo /><div className={styles.time}>{this.state.time}</div>
        </div>

        {/* Includes the location and date */}
        <div className={styles.row}>
          <div className={styles['location-container']}>
            <p><i className="fa fa-map-marker" aria-hidden="true" />
              {this.renderLocation()}
            </p>
          </div>
          <p>{this.state.day} {this.state.date}</p>
        </div>

      </div>
    );
  }
}

Header.propTypes = {
  location: PropTypes.string,
};

export default injectIntl(Header);



// WEBPACK FOOTER //
// ./src/components/shared/header/main.jsx